var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-content"},[_c('Temporary'),_vm._v(" "),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticStyle:{"padding-left":"24px"}},[_c('li',[_vm._v("\n\t\t\t\t\tUser Ticket Statistic\n\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("\n\t\t\t\t\tRecent Updated Ticket\n\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("\n\t\t\t\t\tRecent Reported Ticket\n\t\t\t")])])])
}]

export { render, staticRenderFns }